import { Component } from '@angular/core';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-sales-bricks-tab',
  imports: [APITableComponent, TabLayoutComponent],
  providers: [{ provide: TabComponent, useExisting: SalesBricksTabComponent }],
  templateUrl: './sales-bricks-tab.component.html',
})
export class SalesBricksTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Bricks');

  readonly endpoint = '/sale/tables/brick';
  readonly hasChartView = false;
  readonly skipDateRange = false;
  readonly defaultSort: Record<string, 'asc' | 'desc'> = {
    Brick: 'desc',
  };

  override async main(): Promise<void> {}
}
